const API_BASE_URL = 'https://api.andrewdilks.com';

// Common fetch wrapper with error handling
export async function apiRequest(endpoint, options = {}) {
  const defaultOptions = {
    headers: {},
    mode: 'cors',
    credentials: 'same-origin',
  };

  const config = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers,
    },
  };

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, config);
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      return {
        success: false,
        message: errorData.message || `HTTP error! status: ${response.status}`
      };
    }

    const data = await response.json();
    return {
      success: true,
      data: data,
      message: data?.message || "Request successful"
    };

  } catch (error) {
    console.error(`Error in API request to ${endpoint}:`, error);
    return {
      success: false,
      message: "Network error. Please check your connection."
    };
  }
}

// Common POST request helper
export async function apiPost(endpoint, body) {
  return apiRequest(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body)
  });
}

// Common GET request helper
export async function apiGet(endpoint) {
  return apiRequest(endpoint, {
    method: 'GET'
  });
}

// Common DELETE request helper
export async function apiDelete(endpoint, body = {}) {
  return apiRequest(endpoint, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body)
  });
}
